<template>
  <div class="recharge">
    <van-nav-bar :title="$t('infomation.recharge')" left-text="" @click-left="onClickLeft" left-arrow class="custom-navbar"></van-nav-bar>

    <div class="top">
      <div>
        <van-image round width="4.2rem" height="4.2rem" :src="avatarUrl">
          <template v-slot:loading>
            <van-loading type="spinner"/>
          </template>
          <template v-slot:error>
            <img :src="defaultAvatar" class="avatar-fallback" alt="">
          </template>
        </van-image>
        <div class="info">
          <p class="username">
            {{this.userInfo.username}}
          </p>
          <p class="balance">
            {{$t('infomation.amount')}}：{{this.userInfo.money}} Points
          </p>
        </div>
      </div>
    </div>
    
    <div class="kfsm">
      <div class="kf-icon">
        <van-icon name="service" size="1.5rem" color="#667eea" />
      </div>
      <p>
        {{$t('infomation.kfms')}}
      </p>
    </div>
    
    <div class="kf">
      <van-button type="primary" round block size="large" @click="toService" class="service-btn">
        {{$t('infomation.toserve')}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: { ...(this.$store.getters.getUserInfo || {}) },
      defaultAvatar: '/img/mine/avatar.png',
      menu_top: 40,
      isLoading: false,
    };
  },
  computed: {
    avatarUrl() {
      return this.userInfo.header_img || this.userInfo.avatar || this.userInfo.photo || this.defaultAvatar;
    }
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t('common.refresh'));
        } else {
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },

    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.getUserInfo();
          this.$toast(this.$t('common.refresh'));
        } else {
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    
    onClickLeft() {
      this.$router.push("Mine");
    },

    toService() {
      if(this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t('common.noallow'));
      }
    },
    
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if(res.code === 200 || res.code === 0) {
          const account = res.data && typeof res.data === 'object' ? res.data : {};
          this.userInfo = { ...this.userInfo, ...account };
          this.$store.commit('setUserInfoValue', this.userInfo);
          this.menu_top = 15;
          if(this.userInfo.status !== 1) {
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }
        } else if(res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if(localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t('loginRegister');
      this.userInfo.ip = this.$t('loginForMore');
      this.userInfo.header_img = this.defaultAvatar;
    }
  }
};
</script>

<style scoped>
:export {
  gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.recharge {
  width: 100%;
  min-height: 100vh;
  background: #f8f9ff;
}

.custom-navbar {
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%) !important;
}

.custom-navbar ::v-deep .van-nav-bar__content {
  background: transparent;
}

.custom-navbar ::v-deep .van-nav-bar__title {
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}

.custom-navbar ::v-deep .van-icon {
  color: #fff;
  font-size: 20px;
}

.top {
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  padding: 5rem 5% 2rem;
  border-radius: 0 0 30px 30px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.top > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.top .van-image {
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.info {
  text-align: left;
  color: #fff;
  padding-left: 1.5rem;
  flex: 1;
}

.username {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.balance {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0;
}

.kfsm {
  width: 90%;
  margin: 2rem auto;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 1.2rem 1.5rem;
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1);
  border-left: 4px solid #667eea;
}

.kf-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kfsm p {
  text-align: left;
  padding-left: 1rem;
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

.kf {
  margin-top: 3rem;
  padding: 0 5%;
}

.service-btn {
  background: linear-gradient(135deg, #3498db, #8e44ad) !important;
  border: none !important;
  height: 3rem;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.service-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .custom-navbar ::v-deep .van-nav-bar__title {
    font-size: 16px;
  }
  
  .custom-navbar ::v-deep .van-icon {
    font-size: 18px;
  }
  
  .top {
    padding: 4rem 5% 1.5rem;
    border-radius: 0 0 25px 25px;
  }
  
  .username {
    font-size: 1.1rem;
  }
  
  .balance {
    font-size: 0.85rem;
  }
  
  .kfsm {
    width: 88%;
    margin: 1.5rem auto;
    padding: 1rem 1.2rem;
  }
  
  .kfsm p {
    font-size: 0.8rem;
  }
  
  .kf {
    margin-top: 2.5rem;
  }
  
  .service-btn {
    height: 2.8rem;
    font-size: 0.95rem;
  }
}

/* 动画效果 */
.top {
  animation: slideDown 0.6s ease-out;
}

.kfsm {
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.kf {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 充值页面：黑金轻奢主题 */
.recharge {
  color: #f2e7d3;
  background:
    linear-gradient(rgba(3, 5, 8, .84), rgba(3, 5, 8, .97)),
    url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed no-repeat;
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom-navbar {
  height: 4rem;
  border-bottom: 1px solid rgba(220, 181, 101, .44);
  background: rgba(4, 6, 9, .97) !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, .42);
}

.custom-navbar ::v-deep .van-nav-bar__content {
  height: 4rem;
}

.custom-navbar ::v-deep .van-nav-bar__title,
.custom-navbar ::v-deep .van-icon {
  color: #edcd83 !important;
}

.custom-navbar ::v-deep .van-nav-bar__title {
  font-size: 1.2rem;
  font-weight: 780;
  letter-spacing: .08em;
}

.top {
  margin: 1rem;
  width: auto;
  padding: 1.5rem;
  border: 1px solid rgba(220, 181, 101, .36);
  border-radius: 1.6rem;
  background:
    radial-gradient(circle at 90% 10%, rgba(222, 177, 86, .16), transparent 42%),
    linear-gradient(145deg, rgba(18, 20, 24, .96), rgba(5, 8, 12, .98));
  box-shadow: 0 1.3rem 3rem rgba(0, 0, 0, .42), inset 0 1px 0 rgba(255,255,255,.04);
}

.top .van-image {
  border: .22rem solid #d9b565;
  background: #f4efe5;
  box-shadow: 0 0 0 .35rem rgba(220, 181, 101, .1), 0 .7rem 1.5rem rgba(0,0,0,.42);
}

.info {
  color: #f3eadb;
}

.username {
  color: #f0d38d;
  font-size: 1.25rem;
  font-weight: 780;
  text-shadow: none;
}

.balance {
  color: #d7c8ad;
  font-size: .98rem;
  opacity: 1;
}

.kfsm {
  width: auto;
  margin: 1rem;
  padding: 1.2rem;
  border: 1px solid rgba(220, 181, 101, .3);
  border-left: 1px solid rgba(220, 181, 101, .3);
  border-radius: 1.3rem;
  background: linear-gradient(145deg, rgba(17, 19, 23, .95), rgba(6, 9, 13, .97));
  box-shadow: 0 .9rem 2.2rem rgba(0, 0, 0, .34), inset 0 1px 0 rgba(255,255,255,.035);
}

.kf-icon {
  width: 3.2rem;
  height: 3.2rem;
  color: #171006;
  border: 1px solid rgba(249, 221, 158, .65);
  background: linear-gradient(135deg, #9e6d2d, #ecd080, #a87331);
}

.kf-icon ::v-deep .van-icon {
  color: #171006 !important;
}

.kfsm p {
  color: #d5cab8;
  font-size: .95rem;
  line-height: 1.65;
}

.kf {
  margin-top: 1.5rem;
  padding: 0 1rem;
}

.service-btn {
  height: 3.5rem;
  color: #171006 !important;
  font-size: 1.05rem;
  font-weight: 800;
  border: 1px solid rgba(250, 224, 165, .7) !important;
  background: linear-gradient(110deg, #a97732, #e7c87c 52%, #b98138) !important;
  box-shadow: 0 .8rem 2rem rgba(185, 130, 48, .34);
}

@media (max-width: 430px) {
  .recharge {
    width: 100%;
    min-width: 0;
    min-height: 100svh;
    overflow-x: hidden;
    padding-bottom: max(20px, env(safe-area-inset-bottom));
    background-attachment: scroll;
  }

  .custom-navbar {
    height: auto;
    min-height: 58px;
    padding-top: env(safe-area-inset-top);
  }

  .custom-navbar ::v-deep .van-nav-bar__content {
    min-height: 58px;
  }

  .custom-navbar ::v-deep .van-nav-bar__title {
    max-width: calc(100% - 96px);
    font-size: 17px;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .top {
    min-width: 0;
    margin: 12px 10px;
    padding: 18px 14px;
    border-radius: 20px;
  }

  .top > div,
  .info {
    min-width: 0;
  }

  .top > div {
    gap: 13px;
  }

  .info {
    padding-left: 0;
  }

  .username,
  .balance {
    max-width: 100%;
    line-height: 1.4;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .username {
    font-size: 18px;
  }

  .balance {
    font-size: 14px;
  }

  .kfsm {
    min-width: 0;
    margin: 12px 10px;
    padding: 15px 13px;
    align-items: flex-start;
    border-radius: 18px;
  }

  .kfsm p {
    min-width: 0;
    padding-left: 11px;
    font-size: 14px;
    overflow-wrap: anywhere;
  }

  .kf {
    margin-top: 20px;
    padding: 0 10px;
  }

  .service-btn {
    height: auto;
    min-height: 52px;
    padding: 9px 12px;
    font-size: 16px;
    line-height: 1.35;
    white-space: normal;
  }
}

@media (max-width: 350px) {
  .top > div {
    align-items: flex-start;
  }

  .top .van-image {
    width: 58px !important;
    height: 58px !important;
    flex: 0 0 58px;
  }
}
</style>
